<template>
    <div
        class="m-accordion"
        :class="{ 'm-accordion--active': !hidden }"
    >
        <div
            class="m-accordion__header"
            @click="hidden = !hidden"
        >
            <p class="m-accordion__title">{{ title }}</p>
        </div>
        <div
            ref="toggle"
            class="m-accordion__toggle"
        >
            <transition name="slide">
                <div
                    class="m-accordion__content"
                    v-if="!hidden"
                >
                    <slot></slot>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hidden: false,
            height: 0,
            ready: false
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        height() {
            this.$refs.toggle.style.setProperty('--animation-slide-height', this.height)
        },
        visible() {
            this.hidden = !this.visible
        }
    },
    methods: {
        getHeight() {
            this.height = window.getComputedStyle(this.$refs.toggle).height
        }
    },
    mounted() {
        this.getHeight()
        this.hidden = !this.visible
    }
}
</script>
